export default "__VITE_ASSET__fVR0R$AF__"